import { ConfirmTrashDialog } from "@/action-dialog/dialogs/ConfirmTrashDialog";
import type { ConfirmTrashOptions } from "@/action-dialog/types";
import { createCallable } from "react-call";
import { useMutationFlow, type MutationFn } from "react-call/mutation-flow";

const UNMOUNTING_DELAY_MS = 200;

export type ConfirmTrashCallableProps = ConfirmTrashOptions & {
  mutationFn?: MutationFn<boolean, void>;
};

export const ConfirmTrashCallable = createCallable<
  ConfirmTrashCallableProps,
  boolean
>(({ call, kind, name, children, mutationFn }) => {
  const submit = useMutationFlow(call, mutationFn);
  const pending = submit.pending;

  return (
    <ConfirmTrashDialog
      open
      kind={kind}
      name={name}
      closeOnConfirm={false}
      isWorking={pending}
      onOpenChange={(open) => {
        if (!open && !pending) {
          call.end(false);
        }
      }}
      onConfirm={() => submit().orEnd(true)}
    >
      {children}
    </ConfirmTrashDialog>
  );
}, UNMOUNTING_DELAY_MS);

ConfirmTrashCallable.displayName = "ConfirmTrashCallable";
